module.exports = __webpack_public_path__ + "img/attachment.dcd4fa3f.svg";